import { metaToConsts } from "@/shared/lib/meta-to-consts";
import { metaToMap } from "@/shared/lib/meta-to-map";
import type { ValueMeta } from "@/shared/model";

type AuthErrorMeta = ValueMeta<string> & {
  description: string;
  message: string;
};

export const AUTH_ERROR_META = [
  {
    id: "AE01",
    name: "AUTH_FAILED",
    label: "인증 실패",
    value: "AUTH_FAILED",
    description: "토큰 만료 또는 잘못된 인증 정보",
    message: "인증 정보가 만료되었습니다. 다시 로그인해 주세요.",
  },
  {
    id: "AE02",
    name: "SESSION_EXPIRED",
    label: "세션 만료",
    value: "SESSION_EXPIRED",
    description: "로그인 세션 시간 초과",
    message: "로그인 세션이 만료되었습니다. 다시 로그인해 주세요.",
  },
  {
    id: "AE03",
    name: "LOGIN_FAILED",
    label: "로그인 실패",
    value: "LOGIN_FAILED",
    description: "아이디 또는 비밀번호 불일치",
    message: "로그인에 실패했습니다. 아이디와 비밀번호를 확인해 주세요.",
  },
  {
    id: "AE04",
    name: "TOKEN_EXPIRED",
    label: "토큰 만료",
    value: "TOKEN_EXPIRED",
    description: "액세스 토큰 유효기간 만료",
    message: "인증이 만료되었습니다. 다시 로그인해 주세요.",
  },
] as const satisfies readonly AuthErrorMeta[];

export const AUTH_ERROR_VALUE = metaToConsts(AUTH_ERROR_META);
export const AUTH_ERROR_MAP = metaToMap(AUTH_ERROR_META);
export type AuthErrorId = (typeof AUTH_ERROR_META)[number]["id"];
